import React, { useEffect, useState } from "react";
import BoxLoader from "../../../components/commons/BoxLoader/BoxLoader";
import { RootState } from "../../../redux/rootReducers";
import {
  getPerformanceEvaluationListAction,
  resetMySpaceError,
  resetMySpaceMessage,
  resetMySpaceSuccess,
  resetPerformanceEvaluationList,
} from "../../../redux/mySpace";
import { resetSession } from "../../../redux/auth";
import { connect } from "react-redux";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { MySpaceMyPEIcon, ViewAllIcon } from "../../../assets/images";
import { PerformanceEvaluationListType } from "../../../redux/mySpace/mySpaceTypes";
import { GetPerformanceEvaluationPayloadType } from "../../../commonTypes/mySpaceType";
type AppProps = {
  history: any;
  token: null | string;
  performanceEvaluationFetching: boolean;
  message: string | null;
  success: number | null;
  statusCode: number | null;
  error: string | null;
  performanceEvaluationList: PerformanceEvaluationListType[]|[];
  performanceEvaluationTotalCount: number;
  dispatchGetPerformanceEvaluationListAction: (data: GetPerformanceEvaluationPayloadType) => void;
  dispatchResetMySpaceSuccess: () => void;
  dispatchResetMySpaceMessage: () => void;
  dispatchResetMySpaceError: () => void;
  dispatchResetSession: () => void;
  dispatchResetPerformanceEvaluationList: () => void;
};
const PEFormModule = ({
  history,
  performanceEvaluationFetching,
  message,
  success,
  token,
  statusCode,
  error,
  performanceEvaluationList,
  performanceEvaluationTotalCount,
  dispatchGetPerformanceEvaluationListAction,
  dispatchResetMySpaceSuccess,
  dispatchResetMySpaceMessage,
  dispatchResetMySpaceError,
  dispatchResetSession,
  dispatchResetPerformanceEvaluationList,
}: AppProps) => {
  const [
    isPerformanceEvaluationListPresent,
    setIsPerformanceEvaluationListPresent,
  ] = useMenuCheck("PE");
  const [limit, setLimit] = useState<number>(20);
  const [offset, setOffset] = useState<number>(0);

  const [
    isAddPEFormButtonPresent,
    setIsAddPEFormButtonPresent,
  ] = useMenuCheck("");

  useEffect(() => {
    dispatchResetMySpaceSuccess();
    dispatchResetMySpaceMessage();
    dispatchResetMySpaceError();
    dispatchResetPerformanceEvaluationList();
    setIsPerformanceEvaluationListPresent(
      "Performance Evaluation List",
      "menu"
    );
    setIsAddPEFormButtonPresent(
      "Add PE Form",
      "menu"
    );
    if (token && isPerformanceEvaluationListPresent) {
      const finalData = {
        token,
        offset,
        limit,
        role: "employee",
      };
      dispatchGetPerformanceEvaluationListAction(finalData);
    }
  }, [isPerformanceEvaluationListPresent]);
  return (
    <>
      <div
        className="boxs w-100 pt-3 pb-3 pl-2 pr-2"
        style={{ height: "125px" }}
      >
        {performanceEvaluationFetching ? (
          <BoxLoader style={{ height: "100%" }} />
        ) : (
          <>
            <div style={{ display: "flex", gap: "6px", marginTop: "10px" }}>
              <img src={MySpaceMyPEIcon} alt="PE Form Icon" style={{width:'67px'}}/>
              <div>
                <span className="boxs-container-heading">My PE Forms</span>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ fontSize: "35px", fontWeight: 500 }}>
                      {performanceEvaluationTotalCount}
                    </div>
                    {isAddPEFormButtonPresent && (
                    <button
                      className="btn btn-outline btn-sm ml-2"
                      onClick={() =>
                        history.push({
                          pathname: "/my-space/performance-evaluation-add",
                        })
                      }
                    >
                      Upload
                    </button>
                    )}

                    {isPerformanceEvaluationListPresent && (
                      <div
                        className="ml-3"
                        style={{ color: "#dd4433", cursor: "pointer" }}
                        onClick={() => {
                          history.push({
                            pathname: `/my-space/performance-evaluation-list`,
                            state:{ activeTab:"myPe"}
                          });
                        }}
                      >
                        <img src={ViewAllIcon} alt="View All Icon" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  message: state.mySpace.message,
  success: state.mySpace.success,
  statusCode: state.mySpace.statusCode,
  error: state.mySpace.error,
  performanceEvaluationList: state.mySpace.performanceEvaluationList,
  performanceEvaluationTotalCount:
    state.mySpace.performanceEvaluationTotalCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetPerformanceEvaluationListAction: (data: GetPerformanceEvaluationPayloadType) =>
    dispatch(getPerformanceEvaluationListAction(data)),
  dispatchResetMySpaceSuccess: () => dispatch(resetMySpaceSuccess()),
  dispatchResetMySpaceMessage: () => dispatch(resetMySpaceMessage()),
  dispatchResetMySpaceError: () => dispatch(resetMySpaceError()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetPerformanceEvaluationList: () =>
    dispatch(resetPerformanceEvaluationList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PEFormModule);
